module.exports = __webpack_public_path__ + "communication-48-x-48.7359587d893b18bce8f5.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/communication/webfont/communication-48-x-48.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/communication/webfont/communication-48-x-48.ttf
// module chunks = styles